import type { BlockType } from '@unifyapps/defs/types/block';
import type { JavaScriptVariable } from '@unifyapps/defs/types/javascriptVariable';

export { InterfaceModes } from '../../const';

export type InterfaceStoreRefType = {
  getPageScopeKey: () => string | undefined;
  updateBlocks: ({
    added,
    deleted,
    changed,
  }: {
    added: BlockType[];
    deleted: BlockType[];
    changed: BlockType[];
  }) => void;
  updatePageVariables: ({
    added,
    deleted,
    changed,
  }: {
    added: JavaScriptVariable[];
    deleted: JavaScriptVariable[];
    changed: JavaScriptVariable[];
  }) => void;
};

// TODO: 101 @iamsaumya delete this and use the one from global app state store
export enum InterfaceClient {
  // eslint-disable-next-line @typescript-eslint/naming-convention -- UA is short for UnifyApps
  UA_PLATFORM = 'UA_PLATFORM',
  // eslint-disable-next-line @typescript-eslint/naming-convention -- UA is short for UnifyApps
  UA_MATRIX = 'UA_MATRIX',
}
